<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <!-- {{ this.ferg() }} -->
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">EDITAR PERIODO</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      ref="name"
                      v-model="data.name"
                      :rules="nameRules"
                      label="Nombre"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="company"
                      v-model="data.company"
                      :items="itemsCompany"
                      item-value="_id"
                      item-text="name"
                      :search-input.sync="search"
                      label="Empresa"
                      placeholder="Digite el nombre de la empresa"
                      :disabled="isMaster == 0"
                      clearable
                      :rules="fieldRules"
                    >
                    </v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="state"
                      v-model="data.state"
                      :items="[1, 0]"
                      label="Estado"
                      :rules="fieldRules"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        {{ item == 1 ? 'Activo' : 'Inactivo' }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        {{ item == 1 ? 'Activo' : 'Inactivo' }}
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  :disabled="!valid"
                  depressed
                  large
                  color="primary"
                  @click="validate"
                  >GUARDAR</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'PeriodEditComp',
  components: {},
  props: ['visible', 'data'],
  data() {
    return {
      valid: true,
      serviceRule: [(v) => !!v || 'El campo es requerido'],
      nameRules: [(v) => !!v || 'El campo es requerido'],
      fieldRules: [(v) => v != null || 'El campo es requerido'],
      search: '',
      itemsCompany: [],
    }
  },
  async mounted() {
    await this.getJsonData()
    // evento despues de nueva estacion
    this.$root.$on('reload', async () => {
      await this.getJsonData()
    })
  },
  updated() {
    if(this.isMaster == 0) {
      this.data.company = this.itemsCompany[0];
    }
  },
  watch: {
    search: {
      handler(val) {
        if(val != null && val.length > 1) this.getJsonData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['updatePeriod', 'alertSnackbar']),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm()
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token }

          axios
            .get(
              `company/list?page=1&search=${this.search}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.itemsCompany = res.data.docs
              resolve(res.data)
            })
            .catch((error) => {
              reject(error.response.status)
            })
        })
      } catch (error) {
        throw new Error(error.response.data)
      }
    },
    async registerForm() {
      try {
        let form = {
          _id: this.data._id,
          name: this.data.name,
          company: this.data.company,
          state: this.data.state,
        }
        let update = await this.updatePeriod(form)
        this.$refs.form.reset()
        this.show = false
        if (update == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: 'El periodo se ha actualizado.',
          })
          this.$root.$emit('reload') // parametro update tabla
        } else {
          this.alertSnackbar({
            snackbar: true,
            text: 'ocurrio un error con el servidor.',
          })
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: 'ocurrio un error inesperado.',
        })
      }
    },
  },
  computed: {
    ...mapGetters(['getListCompany','isMaster']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset()
          this.$emit('close')
        }
      },
    },
  },
}
</script>
<style lang="scss" scope>
@import '../../assets/scss/base.scss';
</style>
